import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from "axios";
import { API_CONFIG } from "@/constants/api";
import { KeycloakService } from "./keycloakService";

class ApiClient {
  private client: AxiosInstance;

  constructor() {
    this.client = axios.create({
      baseURL: API_CONFIG.BASE_URL,
      timeout: API_CONFIG.TIMEOUT,
      headers: API_CONFIG.DEFAULT_HEADERS,
    });

    this.setupInterceptors();
  }

  private setupInterceptors() {
    // Request Interceptor - Adiciona token de autenticação
    this.client.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        const token = KeycloakService.getAccessToken();

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
      },
      (error: AxiosError) => {
        return Promise.reject(error);
      }
    );

    // Response Interceptor - Tratamento de erros de autenticação
    this.client.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error: AxiosError) => {
        // Log detalhado do erro para debug
        if (error.code === "ECONNABORTED") {
          console.error("❌ Requisição cancelada ou timeout:", {
            message: error.message,
            code: error.code,
            config: {
              url: error.config?.url,
              method: error.config?.method,
              timeout: error.config?.timeout,
            },
          });
        } else if (error.code === "ERR_NETWORK") {
          console.error("❌ Erro de rede:", {
            message: error.message,
            code: error.code,
            url: error.config?.url,
          });
        } else {
          console.error("❌ Erro na requisição:", {
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            url: error.config?.url,
            method: error.config?.method,
          });
        }

        if (error.response?.status === 401) {
          // Token inválido - fazer logout
          KeycloakService.logout();
        }

        return Promise.reject(error);
      }
    );
  }

  /**
   * Retorna a instância do axios configurada
   */
  get instance(): AxiosInstance {
    return this.client;
  }
}

// Exportar instância única do cliente
export const apiClient = new ApiClient();
